export class CreateTipoContratoQuienPagaServicioRequest {
  public idTipoContrato!: number
  public idQuienPaga!: number
  public idServicio!: number
}
